import { render, staticRenderFns } from "./MasterFooter.vue?vue&type=template&id=2cb2d1fe&scoped=true"
import script from "./MasterFooter.vue?vue&type=script&lang=js"
export * from "./MasterFooter.vue?vue&type=script&lang=js"
import style0 from "./MasterFooter.vue?vue&type=style&index=0&id=2cb2d1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2d1fe",
  null
  
)

export default component.exports